// Dependencies
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { motion, AnimatePresence } from 'framer-motion';

// Components
import Container from '../../container/container';
import AccordionStyles from './accordion.styles';

export default function Accordion({ layout }) {
  const {
    heading,
    text,
    backgroundColour: bgColor,
    accordion: accordionItems,
  } = layout || {};

  const [activeIndex, setActiveIndex] = useState(null);

  const handleClick = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <AccordionStyles bgColor={bgColor}>
      <div className="width-small">
        <Container>
          {(heading || text) && (
            <div className="top">
              {heading && <h2 className="heading large">{heading}</h2>}
              {text && <div className="text">{parse(text)}</div>}
            </div>
          )}
        </Container>
      </div>

      <Container>
        <div className="bottom">
          <div className="accordion">
            {Array.isArray(accordionItems) &&
              accordionItems.length > 0 &&
              accordionItems.map((item, index) => {
                const isOpen = index === activeIndex;

                return (
                  <div
                    className={`item ${isOpen ? 'active' : ''}`}
                    key={item.summary}
                  >
                    <button
                      className="summary"
                      type="button"
                      onClick={() => handleClick(index)}
                      aria-expanded={isOpen}
                      aria-controls={`accordion-content-${index}`}
                      id={`accordion-summary-${index}`}
                    >
                      <h3 className="heading">{item?.summary}</h3>
                    </button>

                    <AnimatePresence initial={false}>
                      {isOpen && (
                        <motion.div
                          className="expandable"
                          initial={{ height: 0 }}
                          animate={{ height: 'auto' }}
                          exit={{ height: 0 }}
                          transition={{
                            duration: 0.4,
                            ease: [0.25, 1, 0.5, 1],
                          }}
                        >
                          <div className="content">{parse(item?.details)}</div>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>
                );
              })}
          </div>
        </div>
      </Container>
    </AccordionStyles>
  );
}

Accordion.propTypes = {
  layout: PropTypes.shape({
    heading: PropTypes.string,
    text: PropTypes.string,
    backgroundColour: PropTypes.string,
    accordion: PropTypes.arrayOf(
      PropTypes.shape({
        summary: PropTypes.string,
        details: PropTypes.string,
      }),
    ),
  }),
};

Accordion.defaultProps = {
  layout: {
    backgroundColour: 'white',
  },
};
